var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "ul",
    { staticClass: "timeline" },
    [
      _vm.first
        ? _c(
            "li",
            [
              _c(
                "layoutText",
                {
                  staticClass: "audit-date",
                  attrs: { fontSize: 1, color: "#666" }
                },
                [_vm._v(_vm._s(_vm.formatDate(_vm.first.date)))]
              ),
              _c("layoutText", { attrs: { fontSize: 2, color: "#333" } }, [
                _vm._v("Created By " + _vm._s(_vm.userName(_vm.first)))
              ])
            ],
            1
          )
        : _vm._e(),
      _vm.sliced
        ? _c(
            "li",
            { staticClass: "split" },
            [
              _c("layoutText", { attrs: { fontSize: 1, color: "#666" } }, [
                _vm._v("...")
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._l(_vm.tail, function(item) {
        return _c(
          "li",
          [
            _c(
              "layoutText",
              {
                staticClass: "audit-date",
                attrs: { fontSize: 1, color: "#666" }
              },
              [
                _vm._v(
                  _vm._s(_vm.formatDate(item.date)) +
                    " by " +
                    _vm._s(_vm.userName(item))
                )
              ]
            ),
            item.type === "PledgeCreatedAuditLogItem"
              ? _c("layoutText", { attrs: { fontSize: 2, color: "#333" } }, [
                  _vm._v("Pledge Created by " + _vm._s(_vm.userName(item)))
                ])
              : _vm._e(),
            item.type === "PledgeUpdatedAuditLogItem"
              ? _c(
                  "Box",
                  [
                    _c(
                      "layoutText",
                      { attrs: { fontSize: 2, color: "#333" } },
                      [
                        _vm._v(
                          "Pledge Updated by " + _vm._s(_vm.userName(item))
                        )
                      ]
                    ),
                    _c("PledgeUpdateAuditItem", { attrs: { item: item } })
                  ],
                  1
                )
              : _vm._e(),
            item.type === "FundraiserAssignedAuditLogItem"
              ? _c("layoutText", { attrs: { fontSize: 2, color: "#333" } }, [
                  _vm._v("Fundraiser Assigned by " + _vm._s(_vm.userName(item)))
                ])
              : _vm._e(),
            item.type === "FundraiserRemovedAuditLogItem"
              ? _c("layoutText", { attrs: { fontSize: 2, color: "#333" } }, [
                  _vm._v("Fundraiser Removed by " + _vm._s(_vm.userName(item)))
                ])
              : _vm._e(),
            item.type === "PaymentAppliedAuditLogItem"
              ? _c("layoutText", { attrs: { fontSize: 2, color: "#333" } }, [
                  _vm._v("Payment Applied by " + _vm._s(_vm.userName(item)))
                ])
              : _vm._e(),
            item.type === "PaymentApplicationRemovedAuditLogItem"
              ? _c("layoutText", { attrs: { fontSize: 2, color: "#333" } }, [
                  _vm._v("Payment Removed by " + _vm._s(_vm.userName(item)))
                ])
              : _vm._e(),
            item.type === "PaymentApplicationUpdatedAuditLogItem"
              ? _c("layoutText", { attrs: { fontSize: 2, color: "#333" } }, [
                  _vm._v("Payment Updated by " + _vm._s(_vm.userName(item)))
                ])
              : _vm._e(),
            item.eventType === "payments-invoiceSent"
              ? _c("layoutText", { attrs: { fontSize: 2, color: "#333" } }, [
                  _vm._v("Invoice Sent by " + _vm._s(_vm.userName(item)))
                ])
              : _vm._e(),
            item.eventType === "payments-receiptSent"
              ? _c("layoutText", { attrs: { fontSize: 2, color: "#333" } }, [
                  _vm._v("Receipt Sent by " + _vm._s(_vm.userName(item)))
                ])
              : _vm._e()
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }